import React from "react";

const PDFBadge = () => {
  return (
    <div
      style={{
        background: "#E85C4A",
        color: "white",
        padding: "6px 14px",
        borderRadius: "8px",
        fontSize: "12px",
        fontWeight: 600,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "fit-content"
      }}
    >
      PDF
    </div>
  );
};

export default PDFBadge;

